<div class="forms-container">
    <h3 class="form-field-title" [ngClass]="!isMarginRequired ? 'label-style' : 'label-style-small-fields'">{{ props.label }}<span
            *ngIf="props.required">*</span></h3>
    <span class="form-field-container" #form>
        <ng-container #fieldComponent></ng-container>
    </span>
    <div class="mat-form-field-hint-wrapper" [ngClass]="{'hint-container': isMarginRequired}">
        <div *ngIf="(showErrMessage(field));else hint_field">
            <mat-error>
                <span class="error-message">
                  <formly-validation-message [field]="field"></formly-validation-message>
                </span>
              </mat-error>
        </div>
        <ng-template #hint_field>
            <div *ngIf="isHtml">
                <mat-hint [innerHtml]="props.description"></mat-hint>
            </div>
            <div *ngIf="!isHtml">
                <mat-hint [innerText]="props.description"></mat-hint>
            </div>
        </ng-template>
    </div>
</div>